import { render, staticRenderFns } from "./LugarInteres.vue?vue&type=template&id=e64a7492&"
import script from "./LugarInteres.vue?vue&type=script&lang=ts&"
export * from "./LugarInteres.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports